import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SecurityPolicies } from '../services/auth-variables';
import { AuthService } from '../services/auth.service';
import { AppDialogService } from '../services/app-dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class HasManageOrganizationsOrPremiumServicesGuard
  implements CanActivate
{
  private readonly unauthorizedRouteMessageKey = 'Unauthorized.InsufficientRights';

  constructor(
    private authService: AuthService,
    public router: Router,
    private appDialogService: AppDialogService,
    private translate: TranslateService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.authService
      .passesPolicyOf(
        SecurityPolicies.RequiresManageOrganizationsOrPremiumServices,
      )
      .pipe(
        map((isAllowed) => {
          if (isAllowed) {
            return true;
          }

          this.appDialogService.showErrorMessage(
            this.translate.instant(this.unauthorizedRouteMessageKey),
          );
          return this.router.parseUrl('/dashboard');
        }),
      );
  }
}
